<ng-lottie *ngIf="show" [options]="optionsLottie"></ng-lottie>
